<template>
    <div  class="d-flex align-items-center justify-content-center w-100 h-100">
        <h5 class="mb-0">
            <b-badge
                    v-if="params.value"
                    @click="click"
                    :variant="params.variant"
                    :class="params.class"
            >
                {{ params.value }}
            </b-badge>
        </h5>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    async click() {
      if (!this.params.onClick) {
        return;
      }

      await this.params.onClick();
    },
  },
});
</script>
